import type { CollectionLinkRecord } from '@/lib/blocks/collection/records';
import { cmsPagesPreviewPath } from '@/lib/routes';
import { normalizeRootRelativePath } from '@/lib/utils';

export function collectionItemHref(record: CollectionLinkRecord, isPreview: boolean): string {
  if (isPreview && record.pageId) {
    return cmsPagesPreviewPath({ id: record.pageId });
  }

  return record.path ? normalizeRootRelativePath(record.path) : '';
}

export const blogHref = collectionItemHref;
export const caseResultHref = collectionItemHref;
